window.initializeQuickViewButtons = function() {
    document.querySelectorAll(".product-card .mbl-quickview--btn button[data-product-id]").forEach(button => {
      button.addEventListener("click", e => {
        e.preventDefault();     
       
        // Get the product URL from the button's data attribute
        // const productUrl = button.getAttribute("data-product-url");
        
       
       
        const productUrl = button.closest('.product-card__media')?.querySelector('.product-card__image-link')?.getAttribute('href') || '';   
        // const xproductUrl = ``;     

        const xproductUrl = `${productUrl}`;
        // const xproductUrl = `${productUrl}&section_id=template--17226260938818__info`;
        // const tempProductUrl = `${productUrl}`;
        // const tempProductUrl = `${productUrl}&section_id=mclbx-track-product-section-id`;
        // const xproductUrl = `${productUrl}&section_id=product-information-v2`;
        // const xproductUrl = `${productUrl}&section=info`;
        // const tempProductUrl = `${productUrl}&sections=product-information-v2`;

        //  fetch(tempProductUrl)
        //   .then((res) => res.text())
        //   .then((res) => {
        //       const wholehtml = new DOMParser().parseFromString(res, "text/html");
        //       const html = wholehtml.querySelector('#--custom-product-section');
        //       console.log("First Html",wholehtml)      
               

        //     }
        //   )
        //   .catch((err) => {
        //     console.error("Fetch error:", err);
        //   });






        console.log("Fetch Url", xproductUrl);
        

        // Check if quick view is already open
        if (document.body.classList.contains("adding-to-cart")) {
          return;
        }
         
        if (productUrl) {
          document.body.classList.add("adding-to-cart");

          fetch(xproductUrl)
            .then((res) => res.text())
            .then((res) => {

  
              const wholehtml = new DOMParser().parseFromString(res, "text/html");
              const html = wholehtml.querySelector('#--custom-product-section');
              console.log("wholehtml: ",wholehtml)
              if(!html){
                console.log("html missing")
                return;
              }
              // Remove unnecessary elements
              if (html.querySelector(".pinfo-bundle-wrapper")) {
                html.querySelector(".pinfo-bundle-wrapper").remove();
              }
              if (html.querySelector(".product-faq-wrapper")) {
                html.querySelector(".product-faq-wrapper").remove();
              }
              if (window.innerWidth < 600) {
                if (html.querySelector(".pdp-media-lg")) {
                  html.querySelector(".pdp-media-lg").remove();
                }
              }
              
              if (html.querySelector("product-information")) {
                html.querySelector("product-information").setAttribute("data-update-url", "false");
              }

              // Open the product quick view and render content
              if (!productQuickView.container.classList.contains("open")) {
                productQuickView.container.open();
              }

              productQuickView.container.renderContent(
                html.querySelector("#product-information-container").innerHTML
              );
              console.log("Printed values", html)
              window.viewerCountPastDay();
              // window.getDeliveryWindow();
            })
            .catch((err) => console.log(err))
            .finally(() => {
              document.body.classList.remove("adding-to-cart");
            });
        }
      });
    });
  };

  document.addEventListener("DOMContentLoaded", window.initializeQuickViewButtons());





// window.refreshCart = function () {
//   const miniCart =
//     document.querySelector("store-cart-drawer") ||
//     document.querySelector("mini-cart") ||
//     document.querySelector("cart-drawer");

//   document.body.classList.add("adding-to-cart");

//   fetch("/cart.js", {
//     method: "GET",
//     headers: { "X-Requested-With": "XMLHttpRequest" }
//   })
//     .then((response) => response.json())
//      .then((response) => {
    

//         if (miniCart?.renderContents) {
//           miniCart.renderContents(response);
//         }

//         if (miniCart?.open) {
//           miniCart.classList.remove("is-empty");
//           miniCart.open();
//         }

//       })
//     .catch((err) => console.error("Cart refresh failed:", err))
//     .finally(() => {
//       document.body.classList.remove("adding-to-cart");
//     });
// };

window.refreshCart = function () {
  const miniCart =
    document.querySelector('store-cart-drawer') ||
    document.querySelector('mini-cart') ||
    document.querySelector('cart-drawer');

  if (!miniCart || !miniCart.getSectionsToRender) return;

  const sections = miniCart.getSectionsToRender().map((section) => section.id);

  const body = JSON.stringify({
    sections,
    sections_url: window.location.pathname
  });

  // document.body.classList.add('adding-to-cart');

  fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body
  })
    .then((response) => response.json())
    .then((state) => {
      if (miniCart?.renderContents) {
        miniCart.renderContents(state);
      }

      if (miniCart?.open) {
        miniCart.classList.remove('is-empty');
        miniCart.open();
      }
    })
    .catch((err) => console.error('Cart refresh failed:', err))
    .finally(() => {
      // document.body.classList.remove('adding-to-cart');
    });
};

 document.addEventListener("DOMContentLoaded", function () {
   window.cardProductFunc();

  })

// lazy load video

document.addEventListener('DOMContentLoaded', function() {
  const videoSources = document.querySelectorAll('source[data-src]');

  // Function that loads all videos currently in viewport
  window.parseVideoHTML = function (videoHTML){
      const parser = new DOMParser();
      const doc = parser.parseFromString(videoHTML, 'text/html');
      const videoElement = doc.querySelector('video');
     
      const sourceElement = videoElement ? videoElement.querySelector('source') : null;

      return {
        src: sourceElement ? sourceElement.getAttribute('src') : '',
        type: sourceElement ? sourceElement.getAttribute('type') : 'video/mp4',
        poster: videoElement ? videoElement.getAttribute('poster') : '',
        playsinline: videoElement ? videoElement.hasAttribute('playsinline') : false,
        preload: 'metadata',
        autoplay: true
      };
    };
  function loadVisibleVideos() {
    videoSources.forEach(source => {
      if (!source.hasAttribute('data-src')) return; // Already loaded

       const videoData = parseVideoHTML(source.dataset.videoelement);
       console.log("Url", videoData.src)
       const video = source.closest('video');

      if (videoData) {
        source.setAttribute('src', videoData.src);
        source.removeAttribute('data-src');
        video.load();
      }
    });
  }

  // loadVisibleVideos();

  window.addEventListener('scroll', () => {
    console.log("Scrolled Once");
    
  if (document.querySelectorAll('source[data-src]').length > 0) {
      loadVisibleVideos();
    }
  }, { once: true });
  
  });




  // Accessibility
  document.addEventListener('keydown', function (event) {
    if (event.ctrlKey || event.metaKey) return; // Ignore if Ctrl or Command is pressed

    switch (event.key) {
        case 'm': // Jump to menu
            document.getElementById('menu').focus();
            break;
        case 'h': // Jump to headings
            const firstHeading = document.querySelector('h1, h2, h3, h4, h5, h6');
            if (firstHeading) firstHeading.focus();
            break;
        case 'f': // Jump to the form
            document.getElementById('form').focus();
            break;
        case 'b': // Jump to the first button
            document.querySelector('button').focus();
            break;
        case 'g': // Jump to the first graphic
            const firstImage = document.querySelector('img');
            if (firstImage) firstImage.focus();
            break;
        default:
            break;
    }
});

document.addEventListener('DOMContentLoaded', function() {
  // Select all .shopify-section elements
  const sections = document.querySelectorAll('.shopify-section');
  
  // Loop through each section
  sections.forEach((section, index) => {
    // Find the first heading element (h1, h2, h3, etc.) inside this section
    const heading = section.querySelector('h1, h2, h3, h4, h5, h6');
    
    // If a heading is found, set the tabindex attribute
    if (heading) {
      heading.setAttribute('tabindex', index + 1);  // tabindex starts from 1
    }
  });
});


window.setupSectionNavigatorScroll = function() {
    // Select all anchor elements with the specified class
    const anchors = document.querySelectorAll('.--section-navigator');
    
    // Determine if the device is mobile based on window width
    const isMobile = window.innerWidth <= 768;
    const offset = isMobile ? 90 : 150;

    console.log("anchors",anchors)

   
    
    anchors.forEach(anchor => {
        anchor.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent default anchor behavior
            const targetId = this.getAttribute('href').substring(1); // Get target ID without #
            const targetElement = document.getElementById(targetId);
             console.log("Target ",targetId, "offset",offset)
            if (targetElement) {
                const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                    top: elementPosition - offset,
                    behavior: 'smooth'
                });
            }
        });
    });
};


// Call the function after defining it
document.addEventListener('DOMContentLoaded', function() {
    window.setupSectionNavigatorScroll();
});